import $ from 'jquery';
import mapLoader from './yandexmaps.js';
import type from './libs/type';
import debounce from './debounce';
import cookie from './cookie';

// layout-header__main_search-mode
let $page = $('.services-page');
let $mapContainer = $page.find('.services-page__map');
let $countrySelect = $page.find('.services-page__sidebar__country__select');
let $citySelect = $page.find('.services-page__sidebar__city__select');
let $deviceTypeSelect = $page.find('.services-page__sidebar__device-type__select');
let $servicesContainer = $page.find('.services-page__services');
let $cityHelper = $page.find('.services-page__sidebar__city__help');
let $detectCityButton = $cityHelper.find('.services-page__sidebar__city__help__button');
let map;

const countries = {};
const cities = {};
const services = {};
const deviceTypes = {};
let currentCountry = null;
let currentCity = null;
let currentDeviceType = null;
let citySelectize = null;

const EARTH_RADIUS = 6372795;
const calculateDistance = function(lat1, lng1, lat2, lng2) {

    // перевести координаты в радианы
    lat1 = lat1 * Math.PI / 180;
    lat2 = lat2 * Math.PI / 180;
    lng1 = lng1 * Math.PI / 180;
    lng2 = lng2 * Math.PI / 180;

     // косинусы и синусы широт и разницы долгот
    let cos1 = Math.cos(lat1);
    let cos2 = Math.cos(lat2);
    let sin1 = Math.sin(lat1);
    let sin2 = Math.sin(lat2);
    let delta = lng2 - lng1;
    let cosdelta = Math.cos(delta);
    let sindelta = Math.sin(delta);

    // вычисления длины большого круга
    let y = Math.sqrt(Math.pow(cos2 * sindelta, 2) + Math.pow(cos1 * sin2 - sin1 * cos2 * cosdelta, 2));
    let x = sin1 * sin2 + cos1 * cos2 * cosdelta;

    return Math.atan2(y, x) * EARTH_RADIUS;
};

const findNearestCity = function(lat, lng) {
    const cityIds = Object.keys(cities);

    if(cityIds.length) {
        let distance = null;
        let nearCityId = null;

        cityIds.forEach(cityId => {
            const city = cities[cityId];

            let newDistance = calculateDistance(lat, lng, city.coordinates.lat, city.coordinates.lng);

            if(distance) {
                newDistance = Math.min(distance, newDistance)
                if(distance > newDistance) {
                    distance = newDistance;
                    nearCityId = cityId;
                }
            }
            else {
                distance = newDistance;
                nearCityId = cityId;
            }
        });

        return nearCityId;
    }

    return null;
};

const initCountryList = function() {
    if(type.isArray(window.countries) && window.countries.length) {
        let selectHtml = '';

        window.countries.forEach(country => {
            selectHtml+= `<option value="${country.id}">${country.title}</option>`;
            countries[country.id] = country;
        });

        window.cities.forEach(city => {
            cities[city.id] = city;
        });

        $countrySelect.append(selectHtml);
    }
};

const initCityList = function(country_id) {
    if(type.isArray(window.cities) && window.cities.length) {
        let selectHtml = '';

        window.cities.forEach(city => {
            if (country_id == city.country_id) {
                selectHtml+= `<option value="${city.id}" data-latlng="${city.coordinates.lat},${city.coordinates.lng}">${city.title}</option>`;
            }
        });

        $citySelect.children('option:not(:first)').remove();
        $citySelect.append(selectHtml);
    }
};

const initDeviceTypesList = function() {
    if(type.isArray(window.deviceTypes) && window.deviceTypes.length) {
        let selectHtml = '';

        window.deviceTypes.forEach(deviceType => {
            selectHtml+= `<option value="${deviceType.id}">${deviceType.title}</option>`;
            deviceTypes[deviceType.id] = deviceType;
        });

        $deviceTypeSelect.append(selectHtml);
    }
};

const initMap = function() {

    const renderServiceList = function(cityId, serviceId) {
        const keys = Object.keys(services);

        if(keys.length) {
            let html = '';

            keys.forEach(key => {
                const service = services[key];

                let matchDeviceType = true;

                if (service && currentDeviceType && currentDeviceType !== '-1') {
                    matchDeviceType = Object.keys(service.kv_device_types).indexOf(currentDeviceType) !== -1;
                }

                if(service && service.city_id == cityId && matchDeviceType) {
                    const deviceTypes = Object.values(service.kv_device_types);
                    html+= `
                        <li class="service-list__item ${service.id == serviceId ? '_active' : ''}">
                            <h6 class="service-list__title">
                                ${service.title}
                            </h6>` +
                            // ${ deviceTypes.length
                            //         ? `
                            //         <p>
                            //             <b>Принимает:</b><br/>
                            //             ${Object.values(service.kv_device_types).map(title => {
                            //                 return `${title}<br/>`;
                            //             }).join('')}
                            //         </p>
                            //         `
                            //         : ''
                            // }
                            `<br><address class="service-list__address">
                                ${service.address}
                                ${
                                    service.phones.split('\n').reduce((acc, val) => {
                                        return acc + 
                                            `<a href="tel:${val}" class="service-list__phone">
                                                ${val}
                                            </a>`;
                                    }, '')
                                }
                            </address>
                        </li>
                    `;
                }
            });

            $servicesContainer.html(html);
        }
    };

    const setMapPosition = function(cityId, map) {
        const keys = Object.keys(services);
        if(keys.length && currentCity != cityId) {
            const bounds = [];

            keys.forEach(key => {
                const service = services[key];
                if(service && service.city_id == cityId) {
                    bounds.push([service.coordinates.lat, service.coordinates.lng]);
                }
            });
            if(bounds.length > 0 && bounds.length < 2) {
                bounds.push(bounds[0]);
            }

            if(bounds.length > 1) {
                const mapCenter = ymaps.util.bounds.getCenterAndZoom(ymaps.util.bounds.fromPoints(bounds), map.container.getSize());
                map.setCenter(mapCenter.center, Math.max(Math.min(mapCenter.zoom, 14), 6));
            }

            currentCity = cityId;
        }
    };

    const setDeviceType = function(deviceTypeId, map) {
        if(deviceTypeId != '-1') {
            map.geoObjects.get(0).setFilter(function(object) {
                if (currentCountry && currentCountry != '-1') {
                    return object.deviceTypes.indexOf(deviceTypeId) >= 0 && object.countryId == currentCountry;
                }
                return object.deviceTypes.indexOf(deviceTypeId) >= 0;
            });
        }
        else {
            map.geoObjects.get(0).setFilter(function(object) {
                return true;
            });
        }
    };

    const setCountry = function(countryId, map) {
        const bounds = [];

        if(countryId != '-1') {
            map.geoObjects.get(0).setFilter(function(object) {
                if (currentDeviceType && currentDeviceType != '-1') {
                    if (object.deviceTypes.indexOf(currentDeviceType) >= 0 && object.countryId == countryId) {
                        bounds.push(object.geometry.coordinates);
                        return true;
                    }
                }
                if (object.countryId == countryId) {
                    bounds.push(object.geometry.coordinates);
                    return true
                }
                return false;
            });
        }
        else {
            map.geoObjects.get(0).setFilter(function(object) {
                return true;
            });
        }

        if (bounds.length > 1) {
            const mapCenter = ymaps.util.bounds.getCenterAndZoom(ymaps.util.bounds.fromPoints(bounds), map.container.getSize());
            map.setCenter(mapCenter.center, Math.max(Math.min(mapCenter.zoom, 14), 3));
        }
    };

    mapLoader(
        'map',
        {
            center: [56.339609, 30.531475],
            //center: mapCenter,
            zoom: 9
        },
        function(_map)
        {
            const map = _map;

            if(!(type.isArray(window.serviceCenters) && window.serviceCenters.length)) {
                return;
            }

            ymaps.option.presetStorage.add('irbis#default', {
                iconContent: '10',
                iconLayout: 'default#image',
                iconImageHref: '/img/map-pin.png',
                iconImageSize: [30, 30],
                iconImageOffset: [-15 ,-15]
            });

            const points = {
                "type": "FeatureCollection",
                "features": []
            };

            Array.prototype.slice.call(window.serviceCenters, 0).forEach(point => {
                points.features.push({
                    type: 'Feature',
                    id: point.id,
                    countryId: point.city.country_id,
                    deviceTypes: typeof(point.kv_device_types) === 'object' ? Object.keys(point.kv_device_types) : [],
                    geometry: {
                        type: 'Point',
                        coordinates: [point.coordinates.lat, point.coordinates.lng]
                    },
                    options: {
                        preset: 'irbis#default'
                    },
                    properties: {
                        balloonContentHeader: point.title,
                        balloonContentBody: point.address + '<br>' + point.phones.replace('\n', '<br>'),
                    }
                });

                services[point.id] = point;
            });

            const objectManger = new ymaps.ObjectManager({
                clusterize: true
            });

            objectManger.add(points);
            map.geoObjects.add(objectManger);

            const mapCenter = ymaps.util.bounds.getCenterAndZoom(objectManger.getBounds(), map.container.getSize());
            map.setCenter(mapCenter.center, mapCenter.zoom);

            objectManger.clusters.events.add(['add'], function(e) {
                e.get('child').options.preset = 'irbis#default';
            });

            objectManger.clusters.each(function(cluster) {
                objectManger.clusters.setClusterOptions(cluster.id, {
                    preset: 'irbis#default'
                })
            });

            objectManger.objects.events.add(['click'], function(e) {

                const service = services[e.get('objectId')];

                if(service) {

                    $cityHelper.hide();

                    $citySelect.get(0).value = service.city_id;
                    $citySelect.trigger('change');

                    setMapPosition(service.city_id, map);
                    renderServiceList(service.city_id, service.id);
                }
            });

            map.events.add(['actionend'], debounce(function() {
                if(map.getZoom() >= 8) {
                    const [lat, lng] = map.getCenter();

                    const cityId = findNearestCity(lat, lng);

                    // fix trash in cities table
                    if (cities[cityId].title === 'С-Петербург' &&
                        (cities[currentCity].title === 'С-Петербург' || cities[currentCity].title === 'Санкт-Петербург')
                    ) {
                        return;
                    }

                    if(cityId != currentCity) {
                        $countrySelect.get(0).value = cities[cityId].country_id;

                        $citySelect.get(0).value = cityId;
                        $citySelect.trigger('change', 'nonavigate');

                        renderServiceList(cityId);

                        currentCity = cityId;
                    }
                }
            }, 500));

            $countrySelect.on('change', function(e, data) {
                const id = $countrySelect.val();

                if(countries[id]) {
                    setCountry(id, map);
                    currentCountry = id;
                    currentCity = null;
                    initCityList(id);
                    renderServiceList();
                }
            });

            $citySelect.on('change', function(e, data) {
                const id = $citySelect.val();

                $cityHelper.hide();

                if(cities[id] && data !== 'nonavigate') {
                    setMapPosition(id, map);
                    renderServiceList(id);
                }
            });

            $deviceTypeSelect.on('change', function(e, data) {
                const id = $deviceTypeSelect.val();

                if(deviceTypes[id] && data !== 'nonavigate') {
                    setDeviceType(id, map);
                    currentDeviceType = id;
                    renderServiceList(currentCity);
                }
            });

            let isDetectingCity = false;

            $detectCityButton.on('click', function(e) {
                e.preventDefault();

                if(isDetectingCity) {
                    return;
                }

                isDetectingCity = true;

                let busyLabel = $detectCityButton.attr('data-busy-label');
                let defaultLabel = $detectCityButton.text();

                if(busyLabel) {
                    $detectCityButton.find('span').eq(0).text(busyLabel)
                }

                ymaps.geolocation.get().then(function(res) {
                    isDetectingCity = false;

                    const geoObject = res.geoObjects.get(0);

                    if(geoObject) {
                        const [lat, lng] = geoObject.geometry.getCoordinates();

                        let cityId;
                        try {
                            cityId = findNearestCity(lat, lng);
                        }
                        catch(e) {
                            console.info('error', e);
                        }

                        if(cityId) {
                            $countrySelect.get(0).value = cities[cityId].country_id;

                            $citySelect.get(0).value = cityId;
                            $citySelect.trigger('change');

                            setMapPosition(cityId, map);
                            renderServiceList(cityId);

                            cookie.set('service_detect_city', cityId, 180)
                        }
                        else {
                            alert('К сожалению не удалось определить ваш город!');
                        }

                        if(defaultLabel) {
                            $detectCityButton.find('span').eq(0).text(defaultLabel)
                        }
                    }

                }, function(e) {
                    isDetectingCity = false;

                    if(defaultLabel) {
                        $detectCityButton.find('span').eq(0).text(defaultLabel)
                    }

                    cookie.set('service_detect_city', 'null', 180)
                })
            });

            let detectedCity = cookie.get('service_detect_city');
            if(detectedCity) {
                if(cities[detectedCity]) {
                    $citySelect.get(0).value = detectedCity;
                    $citySelect.trigger('change');
                }
            }
            else {
                $cityHelper.show();
            }
        }
    );
};


const init = function()
{
    window.$ = $;
    if($page.length) {
        initMap();
        initCountryList();
        initDeviceTypesList();
    }
};

export default init;
